import { useState, useRef } from "react";
import styles from "./index.module.scss";
import { SearchComponent } from "../../../Common/SearchFilterComponent/SearchComponent";
import IPAddressTable from "../ip-address-table";
import TrashIcon from "../../../icons/trash.icon";

const TrustedIPRanges = ({ ipAddresses, onEdit, onDelete, isUpdatingIPAddress }) => {
  const [searchValue, setSearchValue] = useState("");
  const searchRef = useRef(null);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearchClear = () => {
    setSearchValue("");
  };

  const handleSetRef = () => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const filteredIpAddresses = Array.isArray(ipAddresses) 
    ? ipAddresses.filter((ip) =>
        ip.IPAddress && ip.IPAddress.toLowerCase().includes(searchValue.toLowerCase())
      )
    : [];

  const hasNoData = !ipAddresses || !Array.isArray(ipAddresses) || ipAddresses.length === 0;

  return (
    <section
      className={styles.rangesSection}
      aria-labelledby="trusted-ip-ranges-heading"
    >
      <div className={styles.rangesHeader}>
        <h2
          id="trusted-ip-ranges-heading"
          className={styles.rangesTitle}
        >
          Trusted IP ranges
        </h2>

        <div className={styles.rangesActions}>
          <div className={styles.rangesActionGroup}>
            <SearchComponent
              value={searchValue}
              passedRef={searchRef}
              setRef={handleSetRef}
              onChange={handleSearchChange}
              onCross={handleSearchClear}
            />
          </div>

          <button
            onClick={() => !hasNoData && onDelete()}
            disabled={hasNoData}
            className={`${styles.deleteAllButton} ${hasNoData ? styles.deleteAllButtonDisabled : ''}`}
            aria-label="Delete all IP addresses"
          >
            <div className={styles.deleteAllButtonIcon}>
              <TrashIcon className={styles.icon17} />
            </div>

            <div className={styles.deleteAllButtonText}>
              <span className={styles.deleteAllButtonLabel}>Delete All</span>
            </div>
          </button>
        </div>
      </div>

      <IPAddressTable
        ipAddresses={filteredIpAddresses}
        onEdit={onEdit}
        onDelete={onDelete}
        searchValue={searchValue}
        onClearSearch={handleSearchClear}
        allIpAddresses={ipAddresses}
        isUpdatingIPAddress={isUpdatingIPAddress}
      />
    </section>
  );
};

export default TrustedIPRanges;

